// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'jquery/dist/jquery.min'
import '../css/bootstrap.css'
// import '../js/bootstrap.js'
import '../js/bootstrap.min.js'
import * as echarts from 'echarts';
import $user from '@/api/user';
import $req from '@/api/data';
import $util from '@/libs/util';
import ToastInfo from '@/components/toastInfo/toastInfo.js';

// import VueAwesomeSwiper from 'vue-awesome-swiper'

// // import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'

// // import style (<= Swiper 5.x)
// import 'swiper/css/swiper.css'

// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


import ElementUI, { MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.use(ToastInfo);

Vue.prototype.$req = $req
Vue.prototype.$user = $user
Vue.prototype.$http = $req
Vue.prototype.$utils = $util
// Vue.prototype.$alert = MessageBox.alert


Vue.prototype.$rate = {
  fxg: 40,
  cyc: 50,
  wyw: 65,
  byb: 85
}
Vue.prototype.$echarts = echarts;
Vue.prototype.$WebName = false;
Vue.prototype.$WebGbs = false;

Vue.prototype.$resourcesUrl = 'https://www.hbbk68.com/webstatic'
// Vue.prototype.$resourcesUrl = 'https://www.51yhzy.com/webstatic'
// Vue.prototype.$resourcesUrl = 'http://8.142.125.170/webstatic'
// Vue.prototype.$resourcesUrl = 'http://127.0.0.1/webstatic'
Vue.config.productionTip = false;
router.afterEach((to, from, next) => {
  console.log(to.path + "=====" + from.path)
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      //每次执行前，先移除上次插入的代码
      document.getElementById('LA_COLLECT') && document.getElementById('LA_COLLECT').remove();
      document.getElementById('fangwen_tj2') && document.getElementById('fangwen_tj2').remove();
      var hm = document.createElement("script");
      hm.src = "//sdk.51.la/js-sdk-pro.min.js";
      hm.charset = "UTF-8";
      hm.id = "LA_COLLECT"
      document.head.appendChild(hm)

      var hm2 = document.createElement("script");
      hm2.onload = function(){
        LA.init({id: "Jixt2JJEGaTX66GE",ck: "Jixt2JJEGaTX66GE",autoTrack:true,hashMode:true})
      }
      document.head.appendChild(hm2)
    })();
  }, 0);
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js